import React, { useState } from 'react';
import { COLORS } from '../App';

const API_BASE = window.location.port === '3000' ? 'http://localhost:4100/api' : window.location.pathname.startsWith('/cmbs') ? '/cmbs/api' : '/api';

export default function CommitteeTablesResult({ html, documentId, token, hasCompSales, hasCompRents }) {
  const [downloading, setDownloading] = useState(null);
  const [copied, setCopied] = useState(false);

  const download = async (format, label) => {
    setDownloading(format);
    try {
      const res = await fetch(`${API_BASE}/diligence/committee-tables/export/${documentId}/${format}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const blob = await res.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `comp_table_${format}.${format.startsWith('pptx') ? 'pptx' : 'csv'}`;
        a.click();
        URL.revokeObjectURL(url);
      } else {
        const err = await res.json();
        alert(err.error || 'Download failed');
      }
    } catch (err) {
      alert('Download failed: ' + err.message);
    }
    setDownloading(null);
  };

  const copyHtml = () => {
    navigator.clipboard.writeText(html).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const tableStyle = `
    <style>
      .comp-table-container { margin-bottom: 24px; }
      .comp-table-title { font-family: Georgia, serif; font-size: 14px; color: #0F1B2D; margin-bottom: 10px; border-bottom: 2px solid #C9A84C; padding-bottom: 6px; }
      .comp-table { width: 100%; border-collapse: collapse; font-size: 12px; }
      .comp-table th { background: #0F1B2D; color: #fff; padding: 7px 10px; text-align: left; font-weight: 600; }
      .comp-table td { padding: 6px 10px; color: #374151; border-bottom: 1px solid #E5E7EB; }
    </style>
  `;

  return (
    <div>
      {/* Export buttons */}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 14 }}>
        <button onClick={copyHtml}
          style={{ padding: '5px 12px', background: '#F0F2F5', border: `1px solid ${COLORS.border}`, borderRadius: 4, fontSize: 11, cursor: 'pointer', color: COLORS.navy }}>
          {copied ? 'Copied!' : 'Copy HTML'}
        </button>
        {hasCompSales && (
          <>
            <button onClick={() => download('pptx_sales', 'PPTX Sales')} disabled={downloading === 'pptx_sales'}
              style={{ padding: '5px 12px', background: COLORS.navy, color: '#fff', border: 'none', borderRadius: 4, fontSize: 11, cursor: 'pointer', opacity: downloading === 'pptx_sales' ? 0.6 : 1 }}>
              {downloading === 'pptx_sales' ? '...' : 'PPTX — Sales'}
            </button>
            <button onClick={() => download('csv_sales', 'CSV Sales')} disabled={downloading === 'csv_sales'}
              style={{ padding: '5px 12px', background: '#F0F2F5', border: `1px solid ${COLORS.border}`, borderRadius: 4, fontSize: 11, cursor: 'pointer', color: COLORS.navy, opacity: downloading === 'csv_sales' ? 0.6 : 1 }}>
              {downloading === 'csv_sales' ? '...' : 'CSV — Sales'}
            </button>
          </>
        )}
        {hasCompRents && (
          <>
            <button onClick={() => download('pptx_rents', 'PPTX Rents')} disabled={downloading === 'pptx_rents'}
              style={{ padding: '5px 12px', background: COLORS.navy, color: '#fff', border: 'none', borderRadius: 4, fontSize: 11, cursor: 'pointer', opacity: downloading === 'pptx_rents' ? 0.6 : 1 }}>
              {downloading === 'pptx_rents' ? '...' : 'PPTX — Rents'}
            </button>
            <button onClick={() => download('csv_rents', 'CSV Rents')} disabled={downloading === 'csv_rents'}
              style={{ padding: '5px 12px', background: '#F0F2F5', border: `1px solid ${COLORS.border}`, borderRadius: 4, fontSize: 11, cursor: 'pointer', color: COLORS.navy, opacity: downloading === 'csv_rents' ? 0.6 : 1 }}>
              {downloading === 'csv_rents' ? '...' : 'CSV — Rents'}
            </button>
          </>
        )}
      </div>

      {/* Tables rendered inline */}
      <div style={{ border: `1px solid ${COLORS.border}`, borderRadius: 6, overflow: 'hidden', background: '#fff' }}>
        <div dangerouslySetInnerHTML={{ __html: tableStyle + html }} />
      </div>
    </div>
  );
}
